import React from 'react'
import './PlanEntryListLoading.scss'

const PlanEntryListLoading = () => {
  return (
    <div className='PlanEntryListLoading'>
      <div />
    </div>
  )
}

export default PlanEntryListLoading
